import { render } from "./DashboardNotification.vue?vue&type=template&id=40c06d82&scoped=true"
import script from "./DashboardNotification.vue?vue&type=script&lang=js"
export * from "./DashboardNotification.vue?vue&type=script&lang=js"

import "./DashboardNotification.vue?vue&type=style&index=0&id=40c06d82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c06d82"]])

export default __exports__